import React, { useContext } from "react";
import Sidebar from "../components/sidebar/sidebar";
import { Outlet } from "react-router-dom";
import { SidebarContext } from "../context/side-bar-context";
import { SidebarContextType } from "../types/sidebar";

const BaseLayout = () => {
  const { isSideBarOpen, closeSideBar } = useContext(
    SidebarContext,
  ) as SidebarContextType;
  return (
    <main className="page-wrapper">
      <Sidebar />
      <div className={`content-wrapper ${isSideBarOpen ? "sidebar-open" : ""}`}>
        <Outlet />
      </div>
    </main>
  );
};

export default BaseLayout;
